import { useEffect, useState } from 'react';
import { HiOutlineChevronUp } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
const SCROLL_TOP = 200;

const ScrollTop = () => {
   const { t } = useTranslation();
   const [isHidden, setIsHidden] = useState((typeof window !== 'undefined' ? window.scrollY : 0) < SCROLL_TOP);

   useEffect(() => {
      const handleScroll = () => {
         const checkHidden = window.scrollY < SCROLL_TOP;
         if (checkHidden !== isHidden) setIsHidden(checkHidden);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
   }, [isHidden]);

   return (
      <button
         onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
         aria-label={t('a11y.scrollToTop')}
         tabIndex={isHidden ? -1 : 0}
         className="flex items-center justify-center fixed bottom-4 right-4 w-11 h-11 rounded-full bg-lPrimary transition-all duration-[400ms]"
         style={{ opacity: isHidden ? 0 : 1, transform: `translateY(${isHidden ? '10' : '0'}px)`, zIndex: isHidden ? -50 : 50 }}
      >
         <HiOutlineChevronUp className="text-white" />
      </button>
   );
};

export default ScrollTop;
